import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import ListAltIcon from '@material-ui/icons/ListAlt';
import ChatIcon from '@material-ui/icons/Chat';
import SettingsIcon from '@material-ui/icons/Settings';

export const SidebarWrap = styled.div`
    padding-top: 15px;
`

export const Menu = styled.ul`
    list-style: none;
    width: 100%;
    margin-top: 18px;
`

export const Item = styled.li``

export const UserLink = styled(Link)`
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 8px 0 8px 20px;
    color: #333;

    &.active {
        background-color: #feebe9;
        color: #e32;
        font-weight: 700;
    }
`

const totalStyle = css`
    margin-right: 11px;
    font-size: 11px;
    margin-left: auto;
`

export const Newstotal = styled.span`
    ${totalStyle};
`

export const CommentTotal = styled.span`
    ${totalStyle};
`

const iconStyle = css`
    margin-right: 12px;
    font-size: 20px;
`

export const SaveIc = styled(ListAltIcon)`
    ${iconStyle};
`

export const CommentIc = styled(ChatIcon)`
    ${iconStyle};
`

export const SettingIc = styled(SettingsIcon)`
    ${iconStyle};
`